import { render, staticRenderFns } from "./DetalleSolicitudAMEX.vue?vue&type=template&id=f648653c&scoped=true&"
import script from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSolicitudAMEX.vue?vue&type=style&index=0&id=f648653c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f648653c",
  null
  
)

component.options.__file = "DetalleSolicitudAMEX.vue"
export default component.exports